export default __webpack_public_path__ + "static/media/trusted_bakers_main_screen.7b810b90.png";